export const calculatePathScore = (data: {
  maxScore: number;
  minValue: number;
  maxValue: number;
  value: number;
}) => {
  return data.value > 0
    ? Math.round(
        Math.max(
          0,
          data.maxScore -
            (data.maxScore * Math.max(0, data.value - data.minValue)) /
              (data.maxValue - data.minValue),
        ),
      )
    : null;
};
